export default {
	login: {
		aside: {
			title: "Simplifiez et gérez en toute sécurité vos comptes bancaires",
			subTitle:
				"Prenez le contrôle de vos finances sans effort grâce à notre application Web garantissant une sécurité totale.",
		},
		authCard: {
			title: "Connexion",
			info: {
				about: "Nous vous appellerons ou vous enverrons un code pour confirmer votre email.",
				privacy: "Politique de confidentialité."
			},
			continueBtn: "Continuer",
			wordSeparator: "ou continuer avec",
			email: {
				title: "Email",
				placeholder: "Email",
			},
			oAuthButtons: {
				facebook: {
					alt: "Facebook icône",
					btn: "Continuer avec Facebook",
					icon: "src/assets/facebook_icon.svg",
				},
				google: {
					alt: "Google icône",
					btn: "Continuer avec Google",
					icon: "src/assets/google_icon.svg",
				},
				apple: {
					alt: "Apple icône",
					btn: "Continuer avec Apple",
					icon: "../src/assets/apple_icon.svg",
				},
			},
		},
		emailCode: {
			title: "Email code",
			description: "Entrez le code envoyé par e-mail. L'envoi peut prendre quelques secondes. Pensez également à vérifier votre dossier spam.",
			loader: "Chargement",
			sendButtonCode: {
				question: "Renvoyer l'email ? ",
				send: "Envoyer",
			},
			success: 'Code envoyé',
			error: 'Une erreur s\'est produite, veuillez réessayer ou nous contacter'
		},
		mail: {
			empty: "Veuillez rentrer une adresse mail.",
			wrongFormat: "Le format de l'adresse mail n'est pas correct.",
		},
		template: {
			signIn: "Connexion",
		},
	},
	apiErrors: {
		"ERR_NETWORK": "Erreur réseau",
		"general_server_error": "Erreur interne",
		"intern_email_error": "Une erreur est survenue au niveau de votre email. Veuillez réessayer plus tard ou nous contacter",
		"general_argument_invalid": "Email invalide",
		"bank_account_already_exists": "Le nom du compte bancaire existe déjà.",
		"user_phone_not_found": "Aucun numéro de téléphone n'est associé à ce compte.",
		"user_oauth2_bad_request": "Mauvaise requête.",
		"user_jwt_invalid": "Oops! Une erreur est survenue.",
		"user_invalid_code": "Le code est incorrect.",
		"user_invalid_token": "Code invalide.",
		"user_session_already_exists": "Une session est déjà active.",
		"user_unauthorized": "Vous n'êtes pas auorisé à cela.",
		"user_oauth2_unauthorized": "Le forunisseur d'accès ne vous autorise pas à faire cela.",
		"user_not_found": "Utilisateur introuvable",
		"user_session_not_found": "La session actuelle est introuvable.",
		"user_already_exists": "L'utilisateur existe déjà",
		"user_email_already_exists": "Cette adresse mail existe déjà",
		"user_blocked": "Votre compte a été supprimé. Veuillez nous contacter.",
		"general_rate_limit_exceeded": "La limite de taux pour le compte a été dépassée. Veuillez réessayer d'ici 1h.",
		"general_access_forbidden": "Vous n'êtes pas autorisé à accéder à cette page.",
		"general_unauthorized_scope": "Vous devez vous connecter pour accéder à cette page.",
		"error/bad-request": "Vérifiez le format des valeurs fournies.",
		"error/internal-error":
			"Oups, une erreur interne est survenue. Veuillez nous contacter.",
		"auth/email-wrong-format": "Le format d'email n'est pas correct.",
		"auth/internal-error": "Oups... Une erreur s'est produite, nous ne pouvons pas vous authentifier pour le moment, veuillez réessayer ou nous contacter",
	},
	loader: {
	  content: 'Chargement, cela peut prendre du temps',
	},
	demoBanner: {
		title: 'Mode démo actif',
		descriptionBold: 'Explorez',
		description: 'avec des données d\'exemple. Désactivez pour voir vos vraies données',
		btnRefresh: 'Nouvelles données',
		btn: 'Désactiver le mode démo',
	},
	badgeDemoContent: 'Données de démo',
	pageTitle: {
	  isTyping: "En cours de frappe...",
		isSaving: "Sauvegarde en cours...",
		saved: "Sauvegardé !",
		inputPlaceholder: "Entrez le nouveau nom...",
		hint: "💡 Entrer le nouveau nom du compte, il sera sauvegardé automatiquement",
		saveError: "Erreur lors de la sauvegarde",
  },
	alertBanner: {
		title: "Informations manquantes",
		description: "Pensez à renseigner votre nom sur ",
		link: "Paramètres",
	},
	responsiveDrawer: {
		createAccount: {
			title: "Création du compte",
			description: "Nous n'accédons jamais à vos comptes personnels. Les comptes créés sont fictifs et uniquement sur cette application afin de simuler ou gérer votre budget.",
			label: "Nom",
			newAccount: "Nouveau compte",
			createButton: "Créer le compte",
			cancelButton: "Annuler",
		},
		accountsList: {
			title: "Vos comptes",
			description: "Liste de tous vos comptes",
			emptyAccountsList: "Aucun compte créé."
		},
		profile: {
			title: "Profil",
			description: "Préférences générales de votre compte.."
		},
		renameBankAccount: {
		  title: "Renommer le compte bancaire",
			description: "Veuillez entrer le nouveau nom du compte.",
			label: "Nom",
			newName: "Nouveau nom",
			saveButton: "Sauvegarder"
		}
	},
	sidebar: {
		menuItems: {
			dashboard: "Tableau de bord",
			transactions: "Transactions",
			accounts: "Comptes",
			noAccounts: 'Pas de comptes',
			profile: "Profil",
		},
		dropdownProfile: {
			button: "Profil",
			contact: "Contact",
			onboarding: "Tutoriel",
			settings: "Paramètres",
			demoTitle: 'Mode démo',
			demoSubTitleActive: 'Données d\'exemples actives',
			demoSubTitleInactive: 'Activez pour explorer avec des données d\'exemple',
			logout: "Se déconnecter",
		},
		logout: {
			title: 'Confirmation de déconnexion',
			description: 'Etes-vous sûr de vouloir vous déconnecter de l\'application ? Toutes les sessions actives seront fermées et vous devrez vous reconnecter pour accéder à vos informations.',
			success: 'Déconnexion réussie',
		},
		mobileMenu: {
			modalAction: {
				title: "Création d'action",
				description: 'Vous pouvez créer une nouvelle transaction ou un nouveau compte.'
			}
		},
	},
	categoriesList: {
		pets: "Animaux",
		shopping: "Magasins",
		food: "Alimentation & Restaurants",
		insurance: "Assurance et Épargne",
		credits: "Crédits",
		childs: "Enfants",
		account: "Épargne et Investissements",
		taxes: "Impôts, Droits et Frais",
		home: "Logement et Charges",
		recreation: "Loisirs et Vacances",
		withdrawals: "Retraits",
		health: "Santé",
		transportation: "Transports",
		work: "Travail et Études",
	},
	newDashboard: {
		accountsDropdown: {
			default: 'Tous les comptes',
			button: "Changer de compte",
			title: "Comptes",
		},
		greetings: {
			sayHi: "Bonjour, {name}",
			description: "Voici ce qu'il se passe aujourd'hui",
			btnAccount: 'Ajouter un nouveau compte',
			btn: 'Ajouter une transaction',
			btnTooltipContent: "Vous devez créer un compte avant d'ajouter une opération",
			btnTooltipTransactionsDemo: 'Désactivez le mode démo pour créer des transactions',
			btnTooltipAccountDemo: 'Désactivez le mode démo pour créer des comptes',
		},
		card: {
			noLabel: 'Pas de libellé',
			demo: {
				errorFailed: 'Échec de la récupération des données de démonstration, veuillez réessayer ou nous contacter',
			},
			amount: {
				title: "Montant net",
				defaultPlaceholder: "Tous les comptes",
				tooltipContent: "<strong>Montant net</strong> selon la date que vous avez choisie pour le(s) compte(s) sélectionné(s).",
				loader: "Veuillez patienter pendant que nous récupérons vos données",
				missingDatas: 'Créez au minimum un compte, effectuez deux transactions et ajoutez ou modifiez la plage de dates pour afficher le graphique',
				missingDatasDemo: 'Désactivez le mode démo pour commencer à créer des comptes, transactions',
				chartCaption: 'Transactions du {startDate} au {startDate}',
				btnAddAccount: 'Ajouter un compte',
				btnAddTransaction: 'Ajouter une transaction',
				emptyDatas: "Aucunes données",
				footerTitle: "Cliquez sur le graphique, pour plus d'informations",
			},
			traffic: {
				income: {
					name: "Crédit",
					description: 'Gains du {startDate} au {startDate}',
					lastMonth: "vs le mois dernier",
					tooltipContent: "<strong>Montants crédités</strong> selon la date que vous avez choisie pour le(s) compte(s) sélectionné(s).",
				},
				spending: {
					name: "Débit",
					description: 'Dépenses du {startDate} au {startDate}',
					lastMonth: "vs le mois dernier",
					tooltipContent: "<strong>Montants débités</strong> selon la date que vous avez choisie pour le(s) compte(s) sélectionné(s).",
				},
			},
			transactions: {
				title: "Transactions",
				description: "Vos cinq dernières transactions",
				tooltipContent: "<strong>Cinq dernières transactions</strong> selon la date que vous avez choisie pour le(s) compte(s) sélectionné(s).",
				seeMore: "Voir plus de transactions",
				labels: {
					label: "LABEL",
					category: "CATEGORIE",
					amount: "TOTAL",
				},
			},
			categories: {
				title: "Catégories",
				description: "Vos données concernant les catégories de tous vos comptes combinés.",
				tooltipContent: "<strong>Pourcentages des catégories</strong> selon la date que vous avez choisie pour le(s) compte(s) sélectionné(s).",
				labels: {
					category: "CATÉGORIE",
					percentage: "% D'OPÉRATIONS",
					amount: "MONTANT",
				},
			},
		}
	},
	dashboard: {
		empty: {
			title: "Créer un compte bancaire",
			description:
				"C'est bien vide içi.. Commencez par créer un compte bancaire",
		},
		menu: {
			left: {
				firstLink: "Ajouter Permanent",
				secondLink: "Ajouter un compte",
			},
			right: {
				thirdLink: "Paramètres",
				fourthLink: "Déconnexion",
				onboarding: "Commencer Le tutoriel",
			},
			modalLogOut: {
				message: "Êtes-vous sûr de vouloir vous déconnecter ?",
				btnCancel: "Annuler",
				btnConfirm: "Confirmer",
			},
		},
		cardHeader: {
			title: "Total compte",
		},
		card: {
			seeMore: "Voir plus",
			btnDelete: "Supprimer compte",
			titleModalDeleteAccount:
				"Êtes-vous sûr de vouloir supprimer <strong>{account}</strong>",
			tooltip: {
				bookmarked: "Ajouter aux favoris",
			},
		},
		tabs: {
			emptyBookmarked: "Ajoutez un compte en favoris pour le voir ici",
			emptyOthers: "Aucun compte",
			emptySearch: "Entre un compte dans la barre de recherche",
		},
	},
	settings: {
		title: "Réglages",
		subTitle: "Gérez vos préferences",
		tabs: ["Profil", "Notifications", "Gérer les accès et les appareils"],
		dangerousZone: "Zone Dangereuse",
		notificationsTitle: 'Notifications par e-mail',
		sessionsListTitle: 'Gérer vos sessions',
		sessionsColumnsTableHeader: ['Navigateur et appareils', 'Sessions', 'Localisation', 'Ip'],
		sessionsAlertDialogTitle: 'Supprimer session',
		sessionAlertDescriptionCurrentSession: 'Il s\'agit de votre session actuelle, si vous la supprimez, vous serez déconnecté.',
		sessionAlertDescription: 'Êtes-vous sur de supprimer cette session ?',
		sessionAlertBtns: ['Annuler', 'Supprimer'],
		sessionListSuccess: 'Session supprimée',
		notifications: [
			{ title: 'Emails', description: 'Recevez des e-mails sur l\'activité de votre compte' },
			{ title: 'Emails de sécurité', description: 'Recevez des e-mails sur l\'activité et la sécurité de votre compte.' },
		],
		form: {
			success: 'Vos données ont été correctement mises à jour',
			error: "Une erreur est survenue lors de la mise à jour de vos données. Merci de réessayer.",
			btn: 'Mettre à jour',
			userError: "Une erreur est survenue concernant votre profil. Veuillez réessayer plus tard.",
			updateUserError: "Une erreur est survenur lors de la modification, veuillez réessayer plus tard",
			mail: {
				label: "Adresse mail",
				placeholder: 'Entrez votre adresse mail',
				description: 'L\'adresse mail utilisée pour vous authentifier',
				errorFormat: "Le format de l'adresse mail n'est pas correct",
			},
			name: {
				label: 'Prénom',
				description: 'Ceci est votre nom d\'affichage public.',
				placeholder: 'Entrez votre prénom',
			},
			currency: {
				label: "Convertir en devise",
			},
		},
		password: {
			title: "Changer votre mot de passe",
			form: {
				oldPassword: {
					label: "Ancien mot de passe",
				},
				newPassword: {
					label: "Nouveau mot de passe",
				},
				confirmNewPassword: {
					label: "Confirmer nouveau mot de passe",
				},
				btn: {
					update: "Mettre à jour",
				},
			},
		},
		deleteAccount: {
			title: "Supprimer le compte",
			btnDelete: "Supprimer",
			description: "Une fois le compte supprimé, il n’est plus possible de revenir en arrière. Soyez-en sûr, s'il vous plaît.",
			drawer: {
				title: "Supprimer le compte",
				description: "Votre compte est le point d'être supprimé, êtes-vous sûr de vouloir faire cela ?",
				btnCancel: "Annuler",
				btnConfirm: "Confirmer",
				confirmToast: "Votre compte a bien été supprimé.",
			}
		},
	},
	contact: {
		title: "Contact",
		subTitle:
			"Dites-nous si vous rencontrez des problèmes ou des recommandations",
		form: {
			subject: {
				label: "Sélectionnez un sujet",
				types: [
					"Support Client",
					"Support Technique",
					"Recommandations ou Suggestions",
					"Partenariat ou Collaboration",
				],
			},
			message: {
				label: "Écrivez votre message",
			},
			errors: {
				notEmpty: "Ne peut pas être vide",
				apiError: "Une erreur est survenue, veuillez réessayer.",
			},
			success: {
				apiSuccess: "Votre mail a été correctement envoyé.",
			},
		},
	},
	legal_confidentiality: {
	  title: 'Politique de confidentialité',
		link: 'https://www.ticketsapp.money/fr/legal-confidentiality'
	},
	legal_conditions: {
	  title: 'Termes et condiitons',
		link: 'https://www.ticketsapp.money/fr/legal-conditions'
	},
	legal_mentions: {
	  title: 'Mentions légales',
		link: 'https://www.ticketsapp.money/fr/legal-mentions'
	},
	modalAccount: {
		title: "Créer un nouveau compte bancaire",
		form: {
			name: {
				label: "Nom du compte",
				error: "Veuillez renseigner le nom du compte",
				errorLength: "Le nom du compte ne doit pas dépasser 25 caractéres",
				errorAccountNameLength: "Le nom du compte doit contenir au moins 1 caractère",
			},
			amount: {
				label: "Solde initial",
				error: "Veuillez renseigner un solde supérieur à 0",
				errorType: "Veuillez renseigner un chiffre",
			},
			btnSubmit: "Confirmer",
			onSuccess: '{name} crée avec succés',
			onError: 'Un compte portant le même existe déjà.'
		},
	},
	createOp: {
		placeholderFilter: 'Filtrer par libell"',
		sheet: {
			titleAdd: 'Créer une nouvelle transaction',
			subTitle: 'Les transactions sont enregistrées par vos soins et n\'affectent pas vos comptes personnels. Celles-ci vous aident à simuler et gérer votre budget.',
			titleUpdate: 'Mettre à jour la transaction',
			rowsEmpty: 'Aucun résultat, essayez d\'ajouter des transactions',
		},
		form: {
			columns: {
				mandatory: 'Informations Obligatoires',
				optionals: 'Informations Optionnelles',
				title: {
					label: 'Libellé',
					bankAccount: 'Compte bancaire',
					amount: 'Montant',
					categories: 'Catégorie',
					date: 'Date',
				},
				action: {
					dialogTitle: 'Supprimer cette transaction',
					dialogBody: 'Êtes-vous sûr de vouloir supprimer cette transaction ? Ce sera permanent',
					edit: 'Modifier',
				},
				sortable: {
					asc: 'Ascendant',
					desc: 'Descendant',
				},
			},
			rows: {
				bankAccount: {
					title: 'Compte bancaire',
					placeholder: 'Sélectionner un compte bancaire',
				},
				amount: {
					title: 'Montant',
					description: 'Montant de votre opération',
				},
				categories: {
					title: 'Catégories',
					placeholder: 'Ouvrir la liste des catégories',
				},
				date: {
					title: 'Date de la transaction',
					placeholder: 'Choisir une date',
				},
				label: {
					title: 'Libellé',
					placeholder: 'Libellé de la transaction',
					error: 'Veuillez remplir un libellé',
					errorLength: 'Le libellé ne doit pas dépasser 25 caractères',
				},
				type: {
					title: 'Sélectionner le type d\'opération',
					error: 'Veuillez sélectionner un type de transaction',
					errorType: 'Le type de transaction ne peut être que débit ou crédit',
					value: ['Débit', 'Crédit'],
				},
			},
			btn: ['Créer', 'Mettre à jour'],
			onSuccess: 'Transaction créée',
			onUpdate: 'Transaction mise à jour',
			onDelete: 'Transaction supprimée',
		},
	},
	table: {
		modalDeleteTitle: "Êtes-vous sûr de supprimer {adjective}",
		noMoreDataToFetched: "Plus d'opérations à récuperer",
	},
	onboarding: {
		title: "Bienvenue !",
		description: "Tickets vous aide à gérer vos finances de manière efficace. <br/> Vous pouvez créer des comptes, en cliquant sur le bouton <strong>'+ Ajouter un compte'</strong> et enregistrer des transactions bancaires, en cliquant sur le bouton <strong>'+ Ajouter une transaction'</strong>, pour simuler vos dépenses et vos économies, <strong>sans que cela n'ait d'impact sur vos comptes personnels</strong>.",
		btnBegin: "Commencer",
		demoTitle: 'Mode démo activé',
		demoContent: "En tant que nouvel utilisateur, nous activons automatiquement le mode démo pour vous permettre d'explorer avec des données d'exemple. Vous pouvez le désactiver/activer dés que vous le désirez.",
		btnPrev: "Précédent",
		btnNext: "Suivant",
		btnFinish: "Terminer",
		operationsList: {
			title: "Liste d'opérations",
			description:
				'Toutes vos opérations sont listées ici, vous pouvez les éditer en cliquant sur le texte "éditer" ou supprimer une ou plusieurs opérations en les sélectionnant puis en cliquant sur supprimer.',
		},
		searchAccount: {
			title: "Chercher un compte",
			description:
				"Commencez à écrire le nom du compte pour rechercher un compte spécifique.",
		},
		filterAccount: {
			title: "Filtrez vos comptes",
			description:
				"Vous pouvez filtrer vos comptes par favoris, recherche ou autres.",
		},
		congrats: {
			title: "Félicitations",
			description:
				'Vous pouvez si vous le souhaitez relancer le tutoriel en cliquant sur le bouton "Commencer le tutoriel", vous pouvez désormais utiliser l\'application ticket en profitant.',
		},
	},
	transactions: {
		title: 'Transactions',
		subTitle: 'Lister toutes les opérations de tous les comptes bancaires.',
	},
	accountTransactions: {
		title: 'Transactions',
		subTitle: 'Liste de toutes vos transactions pour le compte {name}',
	},
	transactionsMetadata: {
	  bankAccountTotal: 'Total',
		total: 'Transactions inscrites',
		income: 'Revenus',
		spending: 'Dépenses',
	},
	updateAccount: {
	  content: "Le nom du compte bancaire a été modifié."
	}
}
